import { AppDispatch } from '../../../store'
import { setOpenEventDetails } from '../../store/calendarSlice'
import { fetchAppointment } from '../../store/thunks/fetchAppointment'
import {
  IUpdateAppointmentData,
  updateAppointmentActivity,
} from '../../store/thunks/updateAppointmentActivity'
import { ICutForm } from '../../types'
import { IEmptySlotClick } from '../../types/IEmptySlotClick'

export const cutUpdate = (
  openFormDetails: ICutForm,
  lastEmptySlotClick: IEmptySlotClick,
  dispatch: AppDispatch,
) => {
  const cutEvent = openFormDetails.event
  const timeDifference = lastEmptySlotClick.clickedMoment
    .clone()
    .diff(cutEvent.startsAt, 'm')
  const appointActivityArray: IUpdateAppointmentData[] =
    cutEvent.appointmentActivity.map(appActivity => ({
      id: appActivity.id,
      personId: lastEmptySlotClick.person.id,
      startsAt: appActivity.startsAt.clone().add(timeDifference, 'm'),
      endsAt: appActivity.endsAt.clone().add(timeDifference, 'm'),
      updateRepeatAppointments: false,
      isLocked: null,
    }))

  for (
    let i = 0, p = Promise.resolve();
    i < appointActivityArray.length;
    i += 1
  ) {
    p = p
      .then(() =>
        dispatch(
          updateAppointmentActivity({
            data: appointActivityArray[i],
            appointmentUuid: openFormDetails.event.uuid,
          }),
        ),
      )
      .then(() => {
        if (i + 1 === appointActivityArray.length) {
          dispatch(
            setOpenEventDetails({
              openFormDetails: {
                type: 'idle',
                event: null,
              },
            }),
          )
          dispatch(fetchAppointment({ uuid: cutEvent.uuid, type: 'update' }))
          return
        }
      })
  }
}
